import React from "react";
import { Helmet } from "react-helmet-async";
import Contactpage from "./Contactpage";

const ContactUs = () => {
  return (
    <div>
      <Helmet>
        <title>Owision – Contact Owision | Connect With Our Global IT Experts</title>
        <meta
          name="description"
          content="Contact Owision for IT services, support, or partnership. Our global team is here to help with your technology and business transformation needs.
          "
        />
      </Helmet>
      <Contactpage />
    </div>
  );
};

export default ContactUs;
